import { Koi } from '@ksyos/koi';

export const pagingParametersValidator = Koi.object({
    limit: Koi.number().min(1).required(),
    offset: Koi.number().min(0).required(),
}).required();

type getPagingParametersValidatorOptions = {
    maxLimit?: number;
};

export function getPagingParametersValidator(options: getPagingParametersValidatorOptions = {}) {
    const { maxLimit = 100 } = options;

    return Koi.object({
        limit: Koi.number().min(1).max(maxLimit).required(),
        offset: Koi.number().min(0).required(),
    }).required();
}
